<template>
  <form-panel
    width="large"
    title="Nuevo cliente"
    @closePanel="closeModal">
    <div class="title">
      <h5>Los campos marcados son requeridos. Los campos no requeridos se podrán dejar vacios y ser llenados en otra ocasión.</h5>
    </div>
    <customers-form
      :old="oldCustomer"
      @onCreate="test"/>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import CustomersForm from '@/modules/customers/customers-form'

export default {
  name: 'CustomersCreateView',
  components: {
    FormPanel,
    CustomersForm
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    old: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      oldCustomer: {},
      active: 0,
      activities: []
    }
  },
  mounted () {
    this.assignOldUser()
  },
  methods: {
    next () {
      if (this.active++ > 2) this.active = 0
    },
    closeModal () {
      this.$store.dispatch('app/toggleClientPanel')
    },
    assignOldUser () {
      if (this.isEdit) {
        this.oldCustomer = this.old
      }
      return this.oldCustomer
    },
    test (id) {
      this.$emit('onCreate', id)
    }
  }
}
</script>

<style scoped lang="scss">
.title{
  height: 40px;
  padding: 0 30px;
  h5{
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/customers/customers-create-view.vue